import React from 'react';
import {Card, Collapse} from 'antd';
import { RightOutlined, LeftOutlined, DownOutlined } from '@ant-design/icons';
import { observer } from "mobx-react";
import {translateText, getFirstSide} from "../../stores/objects/I18n"
import LocResultsView from "./LocResultsView"

const { Panel } = Collapse;



const MainView = observer(({store}) => {

    let getView = (store, searcher) => {
      switch(searcher.viewerType) {
        case 'loc':
          return (<LocResultsView store={store} searcher={searcher} />);
        case 'no_inline_results':
            return searcher.iframeSupported ? (
              <iframe title={translateText(store, "Results")} src={searcher.targetWebsiteUrl} frameBorder="0"
              style={{position :  "relative", height: "100%", width: "100%"}}/>
              ) : <span/>;
        default:
            throw new Error("Unknown viewer type: " + searcher.viewerType);
                  
      }
    };


    if (store.state.errorMsg) {
      return (
        <Card style={{'textAlign' : 'center',
                       'height': "calc(100vh - 90px)",
                       'color': "red"}}>
          {translateText(store, store.state.errorMsg)}
        </Card>
      )
    }
    if (!store.state.searchExists) {
      return (
        <Card style={{
                        'height': "calc(100vh - 90px)"}}>
          <p>
          {translateText(store, 'The search engine is designed to help find material - books, sources etc. - on any subject related to the U.S.')}
          </p>
          <p>
          {translateText(store, 'Head to the "Searches" panel on the left in order to initiate a new search')}
          </p>
        </Card>
      )
    }
    let resultViewTitle = (s => {
      switch(s.state) {
        case "uninitialized":
          return <span><span>{translateText(store, s.searcherName)}</span>&nbsp;<span>{translateText(store, "(no search yet)")}</span></span>;
        case "unsupported":
          return (<span color="red">
            <span>{translateText(store, s.searcherName)}: </span>
            &nbsp;
            <span>{translateText(store, s.unsupportMsg) + 
           (s.unsupportMsgList === null ? "" : 
            "(" + s.unsupportMsgList.map(x => translateText(store, x)).join(",") + ")")}</span>
            </span>);
        case "error":
          console.log(s.error)
          return (<span color="red">
            <span>{translateText(store, s.searcherName)}</span>
            &nbsp;
            <span>{translateText(store, "(Encountered error while searching)")}</span>
            </span>);
        case "ongoing":
          return (<span>
          <span>{translateText(store, s.searcherName)}</span>
          &nbsp;
          <span>{translateText(store, "(search ongoing)")}</span>
          </span>);
        case "successful":
            let resText =  s.noInlineResults ? "" : s.numResults 
            return (<span>
            <span id={s.searcherName+"Title"}><strong>{translateText(store, s.searcherName)}</strong></span>
            &nbsp;
            <a href={s.targetWebsiteUrl} target="_blank" rel="noopener noreferrer" aria-labelledby={s.searcherName+"Title"}>{resText} {translateText(store, "results")}</a>
            </span>);
        default:
          throw new Error("Unknown searcher state " + s.state);
      }
    });


    return (
      <Card>
        <Collapse 
        defaultActiveKey={store.searcherGroups.map(sg => sg.name)}
        expandIconPosition={getFirstSide(store)}
        expandIcon={({ isActive }) => 
                (!isActive ? (getFirstSide(store) === 'rtl' ? <RightOutlined /> : <LeftOutlined />) : <DownOutlined />)}>
                
        {
          store.searcherGroups.map(sg => (
          <Panel header={(<h2><strong>{translateText(store, sg.name)}</strong></h2>)} key={sg.name}>
            <Collapse defaultActiveKey={[]} 
                      expandIconPosition={getFirstSide(store)}
                      expandIcon={({ isActive }) => 
                      (!isActive ? (getFirstSide(store) === 'rtl' ? <RightOutlined /> : <LeftOutlined />) : <DownOutlined />)}>
            {sg.searchers.map(s => {
              return (
              <Panel header={resultViewTitle(s)} key={s.key} disabled={s.state !== 'successful' || (s.noInlineResults !== true && s.numResults === 0)}>        
                {getView(store, s)}
              </Panel>
              )})}
              </Collapse>
          </Panel>))
          } 
      </Collapse>
    </Card>
  );
  
  });
  
  export default MainView;
